import React from 'react';
import { Helmet } from 'react-helmet';

const StructuredData = ({ data }) => (
  <Helmet defer={false}>
    <script type="application/ld+json">
      {JSON.stringify(data).replace(/</g, '\\u003c')}
    </script>
  </Helmet>
);

export default StructuredData;
